import { IScope } from 'angular'

export interface ReactModalResult {
  action?: string
}

/**
 * Base Controller class for react modals.
 *
 * @class ReactModalController
 */
export class ReactModalController {
  public dismiss: () => void

  constructor(
    protected readonly $scope: IScope,
    protected readonly close: (
      val: Promise<ReactModalResult> | Promise<void>
    ) => void,
    protected readonly vdEscapeStack: any
  ) {
    this.dismiss = () => this.close(Promise.resolve({}))

    // Handle escape key
    this.vdEscapeStack.register(this.dismiss)
    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.dismiss))
  }
}
